import Aos from "../components/aos";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import CtaScrollSection from "../components/CtaScrollSection";
import homepageHeader from "../components/homepageHeader";

/**
 * Front Page
 */
const PageFrontPage = ($) => {
	if ($("body").hasClass("home")) {
		Aos();
		gsap.registerPlugin(ScrollTrigger); // intialize scrollTrigger using Gsap and pass down
		CtaScrollSection(gsap, ScrollTrigger, $); // handles pinning the section on screen
		Aos();

		const handleResize = () => {
			homepageHeader($);
		};

		// set the initial state
		handleResize();
		window.addEventListener("resize", handleResize);
	}
};

export default PageFrontPage;